import { setTimeout } from 'timers';
import { Subscription } from 'rxjs/Subscription';
import { PanelConextMenu } from './panel-context-menu.class';
import { LayoutType } from './../layout-type.interface';
import { SeQuickArtComponent } from './../../screen-elements.module/se-quickart/se-quickart.component';
import { Observable } from 'rxjs/Observable';
import { DesignerGlobalService } from './../../designer-global.service';
import { transition } from '@angular/core/src/animation/dsl';
import { PanelType } from './../panel-type.interface';
import { DynamicComponentDirective } from './../../../../../core.module/directives/dynamic-component-container.directive';

import { Screen } from './../../../../../shared/sdk/models/Screen';
import { LoopBackConfig } from './../../../../../shared/sdk/lb.config';
import { LoggerService } from './../../../../../shared/sdk/services/custom/logger.service';
import { GlobalPropertiesService } from './../../../../../core.module/services/global-properties.service';
import { ScreenApi } from './../../../../../shared/sdk/services/custom/Screen';
import { ServicesApi } from './../../../../../shared/sdk/services/custom/Services';
import { LibraryApi } from './../../../../../shared/sdk/services/custom/Library';
import { KanvasUserApi } from './../../../../../shared/sdk/services/custom/KanvasUser';
import { ContainerApi } from './../../../../../shared/sdk/services/custom/Container';
import { DataService } from './../../../../../core.module/services/data.service';
import { SeLiveVideoComponent } from './../../screen-elements.module/se-live-video/se-live-video.component';
import { SeVideoComponent } from './../../screen-elements.module/se-video/se-video.component';
import { SeLimitedTimeOfferComponent } from './../../screen-elements.module/se-limited-time-offer/se-limited-time-offer.component';
import { SeTextboxComponent } from './../../screen-elements.module/se-textbox/se-textbox.component';
import { SeScrollingtextComponent } from './../../screen-elements.module/se-scrollingtext/se-scrollingtext.component';
import { SeImageComponent } from './../../screen-elements.module/se-image/se-image.component';
import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { DataURLS } from '../../../../../shared/base.url';
import * as _ from 'lodash';
import { IAnimation } from '../../screen-elements.module/ianimation.interface';
import { zip } from 'rxjs/observable/zip';
import { ScreenElementClass } from '../../screen-elements.module/screen-element.class';
import { SeVideoYoutubeComponent } from '../../screen-elements.module/se-video-youtube/se-video-youtube.component';
import { SeShapeComponent } from '../../screen-elements.module/se-shape/se-shape.component';
import { MenuItem } from 'primeng/components/common/menuitem';
import { UUID } from 'angular2-uuid';
import { SeWeatherMultidayComponent } from '../../screen-elements.module/se-weather-multiday/se-weather-multiday.component';
import { ConfirmationService } from 'primeng/components/common/api';

@Component({
  selector: 'app-screen-panel',
  templateUrl: './screen-panel.component.html',
  styleUrls: ['./screen-panel.component.css']
})

export class ScreenPanelComponent implements OnInit {
  @Input() config: PanelType;

  @Output() panelCleared: EventEmitter<ScreenPanelComponent> = new EventEmitter();
  @Output() screenLoaded: EventEmitter<{ screen: Screen, panelRef: ScreenPanelComponent }> = new EventEmitter<{ screen: Screen, panelRef: ScreenPanelComponent }>();
  @Output() screenDeleted: EventEmitter<Screen> = new EventEmitter();
  @Output() screenSaved: EventEmitter<{ screen: Screen, panelRef: ScreenPanelComponent }> = new EventEmitter<{ screen: Screen, panelRef: ScreenPanelComponent }>();

  @Output() componentAdded: EventEmitter<{ screenPanelComponent: ScreenPanelComponent, componentRef: any }> = new EventEmitter();
  @Output() componentDeleted: EventEmitter<{ screenPanelComponent: ScreenPanelComponent, componentRef: any }> = new EventEmitter();

  @Output() mouseDownPanel: EventEmitter<{ screenPanelComponent: ScreenPanelComponent, event: any }> = new EventEmitter();

  // animation events
  @Output() allAnimationsFinished: EventEmitter<Array<Array<IAnimation>>> = new EventEmitter();
  @Output() allVideosFinished: EventEmitter<any> = new EventEmitter();
  // element events
  @Output() mouseOverElement: EventEmitter<{ screenPanelComponent: ScreenPanelComponent, componentRef: any, event: any }> = new EventEmitter();
  @Output() mouseDownElement: EventEmitter<{ screenPanelComponent: ScreenPanelComponent, componentRef: any, event: any }> = new EventEmitter();
  @Output() clickElement: EventEmitter<{ screenPanelComponent: ScreenPanelComponent, componentRef: any, event: any }> = new EventEmitter();
  @Output() touchStartElement: EventEmitter<{ screenPanelComponent: ScreenPanelComponent, componentRef: any, event: any }> = new EventEmitter();
  @Output() touchEndElement: EventEmitter<{ screenPanelComponent: ScreenPanelComponent, componentRef: any, event: any }> = new EventEmitter();
  @Output() scrollElement: EventEmitter<{ screenPanelComponent: ScreenPanelComponent, componentRef: any, event: any }> = new EventEmitter();


  @ViewChild('screenPanel') screenPanel;
  @ViewChild(DynamicComponentDirective) SeContainerRef: DynamicComponentDirective;

  public componentsOnScreen: object[] = [];


  public useCalculatedMinTimeVal = true;  // bound to setting on panel controls dropdown
  get useCalculatedMinTime() {
    return this.useCalculatedMinTimeVal;
  }
  set useCalculatedMinTime(val) {
    this.useCalculatedMinTimeVal = val;
    this.hasChanges = true;
  }

  // transition stuff
  public currentTransition = 'fadeIn';
  public activeTransition = '';
  public useTransition = false;
  public uniqueId = UUID.UUID();

  // items on the panel surface are nested in zindex
  // grid-container is z-index 1
  // display-layout-container is z-index 2
  // background element is 3
  // start elements at z-index 10  to have some space for future things, like a base video element?
  public firstZindex = 10;
  public nextZindex = 10;

  public currentScreen: Screen = new Screen();
  public autoSave: boolean;
  public hasChanges: boolean;
  public showPanelGuides = false;

  public backgroundColor = 'rgba(255,255,255,1)';

  // animation vars
  public playingAnimations = false;
  public playingVideos = false;



  private currentLayout: LayoutType;



  // background component holder (there is only one)
  public backgroundComponent: any;

  constructor(
    public logger: LoggerService,
    public globalProps: GlobalPropertiesService,
    private componentFactoryResolver: ComponentFactoryResolver,
    public confirmationService: ConfirmationService,
    public screenApi: ScreenApi,
    public servicesApi: ServicesApi,
    public libraryApi: LibraryApi,
    public kanvasUserApi: KanvasUserApi,
    public containerApi: ContainerApi,
    public dataService: DataService,
    public injector: Injector,
    public elementRef: ElementRef,
    public renderer: Renderer2,
    public changeDetectorRef: ChangeDetectorRef
  ) {
    LoopBackConfig.setBaseURL(DataURLS.BASE_URL);
    LoopBackConfig.setApiVersion(DataURLS.API_VERSION);
    const startingConfig = this.injector.get('panelConfig');  // get commonConfig Value if injected
    const currentLayout = this.injector.get('currentLayout');  // get currentlayout Value if injected

    if (startingConfig) {
      this.config = startingConfig;
    }

    if (currentLayout) {
      this.currentLayout = currentLayout;
    }
  }

  ngOnInit() {

    this.newScreen();
  }

  // this is called from the player when a preloaded screen is ready, it should start any paused elements
  // or get back to the initial positions and start.. TO DO: add a function to every element for start()
  startAll() {
    this.playTransition();
    this.playAnimations();
    this.playVideos();

    for (const se of this.componentsOnScreen) {
      if ((<any>se).update) {
        let to;
        to = setTimeout(() => {
          (<any>se).update();
          to = null;
        }, 0);

      }

      let to2;
      // stop scrolling text
      if ((<any>se).startScroll) {
        to2 = setTimeout(() => {
          (<any>se).startScroll();
          to2 = null;
        }, 0);

      }
    }
  }

  stopAll() {
    this.stopAnimations();
    this.stopVideos();
    this.stopTransition();

    for (const se of this.componentsOnScreen) {
      if ((<any>se).update) {
        let to;
        to = setTimeout(() => {
          (<any>se).update();
          to = null;
        }, 0);

      }

      let to2;
      // stop scrolling text
      if ((<any>se).stopScroll) {
        to2 = setTimeout(() => {
          (<any>se).stopScroll();
          to2 = null;
        }, 0);

      }
    }

  }

  setPanelGuide(val) {
    this.showPanelGuides = val;
  }

  hasAnimations(): boolean {
    // check all elements for animations
    // get animations ready
    for (const element of this.componentsOnScreen) {
      const seElement = (<any>element); // convienence any
      if (seElement.elementConfig.animations && seElement.elementConfig.animations.length) {
        return true;
      }

    }

    // background element has animation
    if (this.backgroundComponent && this.backgroundComponent.elementConfig.animations && this.backgroundComponent.elementConfig.animations.length) {
      return true;
    }

    return false;
  }

  hasVideos(): boolean {
    // check all elements for animations
    // get animations ready
    for (const element of this.componentsOnScreen) {
      const seElement = (<any>element); // convienence any
      if (seElement.elementConfig.SeType === 'SeVideo' || seElement.elementConfig.SeType === 'SeLiveVideo') {
        return true;
      }

    }

    // background element has animation
    if (this.backgroundComponent && this.backgroundComponent.elementConfig.SeType === 'SeVideo') {
      return true;
    }

    return false;
  }

  async playAnimations() {
    this.playingAnimations = false;

    const SeElementsWithAnimations = [];

    // get animations ready
    for (const element of this.componentsOnScreen) {
      const seElement = (<any>element); // convienence any
      if (seElement.elementConfig.animations && seElement.elementConfig.animations.length) {
        SeElementsWithAnimations.push(seElement);
      }
    }

    // background element has animation
    if (this.backgroundComponent && this.backgroundComponent.elementConfig.animations && this.backgroundComponent.elementConfig.animations.length) {
      SeElementsWithAnimations.push(this.backgroundComponent);
    }


    if (SeElementsWithAnimations.length) {
      // triggers animations on all the items
      this.playingAnimations = true;
      const animationFinishedObservables: Array<Observable<Array<IAnimation>>> = [];

      for (const ele of SeElementsWithAnimations) {
        animationFinishedObservables.push(ele.allAnimationsFinished);
        ele.playAnimations(); // trigger play
      }

      // wait for them all to finish
      await zip(...animationFinishedObservables).take(1).toPromise();

      this.playingAnimations = false;
      this.allAnimationsFinished.emit();
    }

  }

  stopAnimations() {
    for (const element of this.componentsOnScreen) {
      const seElement = (<any>element); // convienence any
      if (seElement.elementConfig.animations && seElement.elementConfig.animations.length) {
        seElement.stopAnimation();
      }

    }
  }

  async playVideos() {
    this.playingVideos = false;

    const SeElementsWithVideos = [];

    // get animations ready
    for (const element of this.componentsOnScreen) {
      const seElement = (<any>element); // convienence any
      if (seElement.elementConfig.SeType === 'SeVideo' || seElement.elementConfig.SeType === 'SeLiveVideo') {
        SeElementsWithVideos.push(seElement);
      }
    }

    // background element has animation
    if (this.backgroundComponent && this.backgroundComponent.elementConfig.SeType === 'SeVideo' || this.backgroundComponent && this.backgroundComponent.elementConfig.SeType === 'SeLiveVideo') {
      SeElementsWithVideos.push(this.backgroundComponent);
    }


    if (SeElementsWithVideos.length) {
      // triggers animations on all the items
      this.playingAnimations = true;
      const videosFinishedObservables: Array<Observable<Array<IAnimation>>> = [];

      for (const ele of SeElementsWithVideos) {
        videosFinishedObservables.push(ele.videoFinished);
        ele.play(); // trigger play
      }

      // wait for them all to finish
      await zip(...videosFinishedObservables).take(1).toPromise();

      this.playingVideos = false;
      this.allVideosFinished.emit();
    }

  }

  stopVideos() {
    for (const element of this.componentsOnScreen) {
      const seElement = (<any>element); // convienence any
      if (seElement.elementConfig.SeType === 'SeVideo' || seElement.elementConfig.SeType === 'SeLiveVideo') {
        seElement.stop();
      }

    }

    if (this.backgroundComponent && this.backgroundComponent.elementConfig.SeType === 'SeVideo' || this.backgroundComponent && this.backgroundComponent.elementConfig.SeType === 'SeLiveVideo') {
      this.backgroundComponent.stop();
    }
  }

  getNextZindex() {
    this.compressZindexs();
    return this.firstZindex + this.componentsOnScreen.length;
  }

  getLowestOpenZindex() {
    const max = this.firstZindex + this.componentsOnScreen.length;
    let lowestIndex = max;
    for (let index = this.firstZindex; index < max; index++) {
      const nextCmp: any = this.componentsOnScreen.find((cmp: any) => {
        return cmp.elementConfig.zIndex === index;
      });

      if (!nextCmp) {
        lowestIndex = index;
        break;
      }

    }
    return lowestIndex;
  }

  getLowestIndex() {
    const max = this.firstZindex + this.componentsOnScreen.length;
    let lowest = max;
    for (const cmp of this.componentsOnScreen) {
      if ((<any>cmp).elementConfig.zIndex < lowest) {
        lowest = (<any>cmp).elementConfig.zIndex;
      }

    }

    return lowest;
  }

  compressZindexs() {
    const max = this.firstZindex + this.componentsOnScreen.length;

    for (const cmp of this.componentsOnScreen) {
      const lowestUsed = this.getLowestIndex();
      const lowestOpen = this.getLowestOpenZindex();

      if (lowestUsed > lowestOpen || (<any>cmp).elementConfig.zIndex > lowestOpen) {
        (<any>cmp).elementConfig.zIndex = lowestOpen;
      }

    }

  }

  zIndexUp(componentRef) {

    if (componentRef.elementConfig.zIndex < this.getNextZindex()) {
      // find next component
      const nextCmp: any = this.componentsOnScreen.find((cmp: any) => {
        return cmp.elementConfig.zIndex === componentRef.elementConfig.zIndex + 1;
      });
      // swap positions with the next element in line
      if (nextCmp) {
        nextCmp.elementConfig.zIndex = componentRef.elementConfig.zIndex;
        componentRef.elementConfig.zIndex += 1;

        this.hasChanges = true;
      }
    }

  }

  zIndexDown(componentRef) {
    if (componentRef.elementConfig.zIndex > this.firstZindex) {
      // find previous component
      const prevCmp: any = this.componentsOnScreen.find((cmp: any) => {
        return cmp.elementConfig.zIndex === componentRef.elementConfig.zIndex - 1;
      });
      // swap positions with the next element in line
      if (prevCmp) {
        prevCmp.elementConfig.zIndex = componentRef.elementConfig.zIndex;
        componentRef.elementConfig.zIndex -= 1;

        this.hasChanges = true;
      }

    }
  }

  async newScreen() {

    await this.clearScreen();
    this.currentScreen = new Screen();
    this.currentScreen.MinimumScheduleTime = 20;
    this.backgroundColor = _.get(this.dataService.currentUser, 'profile.DesignerSettings.defaultBackgroundColor', 'rgba(255,255,255,1)');

    this.useCalculatedMinTime = true;

    // do this last
    this.hasChanges = false;
    // notify that panel has changed
    this.screenLoaded.emit({ screen: this.currentScreen, panelRef: this });
  }

  buildScreenFromCurrentData(): Screen {

    try {
      const screenJson = new Array();
      for (const cmp of this.componentsOnScreen) {
        screenJson.push((<any>cmp).elementConfig.toJson());
      }

      // if (screenJson.length === 0) {
      //   this.logger.info('Not saving screen on navigate, becuase it is empty');
      //   return null;
      // }

      // make thumb and upload
      const html = this.getHtmlOfScreen();
      // const blob = await this.elementToBlob(this.designSurfaceRef.nativeElement);
      // const screenThumbFile = await this.uploadScreenThumb(blob);
      const newScr = _.cloneDeep(this.currentScreen);

      newScr.id = this.currentScreen.id;
      newScr.ScreenName = this.currentScreen.ScreenName;
      newScr.IsTemplate = false;
      newScr.ScreenData = screenJson;
      newScr.Description = this.currentScreen.ScreenName;
      newScr.Width = this.config.width;
      newScr.Height = this.config.height;
      newScr.IsVertical = this.currentLayout && this.currentLayout.isVertical;


      if (this.useCalculatedMinTime) {
        newScr.MinimumScheduleTime = this.getMinimumScheduleTime();
      } else {
        newScr.MinimumScheduleTime = this.currentScreen.MinimumScheduleTime;
      }
      newScr.ScreenSizeInBytes = this.calcScreenBytes();
      // ThumbnailFilename: '', // this is populated by the server after the screen is uploaded

      newScr.Metadata = {
        screenHtml: html,
        backgroundColor: this.backgroundColor,
        useCalculatedMinTime: this.useCalculatedMinTime,
        backgroundComponent: this.backgroundComponent ? this.backgroundComponent.elementConfig.toJson() : null
      }; // the screen shot is generated by the html
      // Categories: '',
      newScr.libraryId = this.dataService.getCurrentUserPrivateLibId();
      return newScr;

    } catch (error) {
      this.logger.error('Error building screen from current props: ', error);
      throw error;
    }

  }

  /**
   * Save screen to server
   *
   * @memberof DesignerGlobalService
   */
  async saveScreen(): Promise<Screen> {
    try {
      this.compressZindexs();  // make sure zindexs are accurate

      const newScr = this.buildScreenFromCurrentData();

      const result = <Screen>await this.screenApi.upsert(newScr).toPromise();
      const updatedScreen = <Screen>await this.screenApi.findById(result.id, { include: [{ 'library': [{ 'kanvasUserPrivateLibrary': 'roles' }, { 'kanvasUserPublicLibrary': 'roles' }] }, 'rotationItems', 'tags', 'playerGroups'] }).toPromise();
      this.currentScreen = updatedScreen;
      this.hasChanges = false;

      // notify that panel has changed
      this.screenSaved.emit({ screen: this.currentScreen, panelRef: this });

      return this.currentScreen;
    } catch (error) {
      // ut oh
      this.logger.error('Error saving screen: ', error);
    }

  }

  async saveAsScreen(copyName) {
    const scrCopy = _.cloneDeep(this.currentScreen);
    scrCopy.ScreenName = copyName;

    delete scrCopy.id; // clear id field

    this.currentScreen = scrCopy; // set current screen to the copy before saving

    const newScr = await this.saveScreen();

    this.loadScreen(newScr);
  }

  async deleteScreen() {

    if (this.currentScreen.id) {
      const result = await this.screenApi.deleteById(this.currentScreen.id).toPromise();
      this.screenDeleted.emit(this.currentScreen);
    }

    this.newScreen();
  }

  async clearScreen() {
    const num = this.componentsOnScreen.length;
    for (let index = 0; index < num; index++) {
      const cmp = this.componentsOnScreen[0];
      await this.deleteComponent(cmp);
    }

    // get rid of background
    await this.deleteBackgroundComp();

    this.hasChanges = true;

    this.panelCleared.emit(this);
  }

  async loadScreen(scr: Screen, makethumbs = true, transitionName = '', autoPlayOnPlayer = true) {
    await this.clearScreen();

    if (transitionName !== '') {
      this.currentTransition = transitionName;
      this.useTransition = true;
    } else {
      this.useTransition = false;
    }

    // remove any previous trasition
    if (this.activeTransition !== '') {
      this.renderer.removeClass(this.screenPanel.nativeElement, 'animated');
      this.renderer.removeClass(this.screenPanel.nativeElement, this.activeTransition);
      this.activeTransition = '';
      this.changeDetectorRef.detectChanges(); // remove animation class
    }

    this.currentScreen = scr;
    // const screenJson = JSON.parse(localStorage.getItem('testScreen'));

    const screenJson = scr.ScreenData;
    // load all the elements
    if (screenJson) {
      for (const cmp of screenJson) {
        this.createComponent(cmp, makethumbs, autoPlayOnPlayer);
      }
    }

    this.currentScreen.IsVertical = this.currentLayout.isVertical;

    this.backgroundColor = _.get(this.currentScreen, 'Metadata.backgroundColor', 'rgba(255,255,255,1)');
    if (this.backgroundColor === 'white') { this.backgroundColor = 'rgba(255,255,255,1)'; } // HACK to fix bad color.  Should not be a color name, should be rgba value

    this.useCalculatedMinTime = _.get(this.currentScreen, 'Metadata.useCalculatedMinTime', true);

    const backgroundConfig = _.get(this.currentScreen, 'Metadata.backgroundComponent', null);

    if (backgroundConfig) {
      this.createBackgroundComp(backgroundConfig);
    }

    this.hasChanges = false; // reset the haschanges flag

    // apply transition if enabled by this.useTransition
    if (this.useTransition && autoPlayOnPlayer) {
      this.playTransition();
    }

    this.screenLoaded.emit({ screen: scr, panelRef: this });

  }

  playTransition() {
    if (this.currentTransition) {
      this.renderer.addClass(this.screenPanel.nativeElement, 'animated');
      this.renderer.addClass(this.screenPanel.nativeElement, this.currentTransition);
      this.activeTransition = this.currentTransition;
    }
  }

  stopTransition() {
    if (this.currentTransition) {
      this.renderer.removeClass(this.screenPanel.nativeElement, 'animated');
      this.renderer.removeClass(this.screenPanel.nativeElement, this.currentTransition);
      this.activeTransition = null;
    }
  }

  getMinimumScheduleTime() {
    // get the longest item on the screen
    let minTime = 0;

    for (const cmp of this.componentsOnScreen) {
      const cmpTime: number = (<any>cmp).getMinimumScheduleTime();
      if (cmpTime > minTime) {
        minTime = cmpTime;
      }
    }

    // also check background component
    if (this.backgroundComponent) {
      const cmpTime: number = (<any>this.backgroundComponent).getMinimumScheduleTime();
      if (cmpTime > minTime) {
        minTime = cmpTime;
      }
    }

    return minTime;
  }

  calcScreenBytes() {
    let totalBytes = 0;

    this.componentsOnScreen.forEach((cmp: any) => {
      totalBytes += cmp.elementConfig.sizeInBytes;
    });

    // also add background component
    if (this.backgroundComponent) {
      totalBytes += this.backgroundComponent.elementConfig.sizeInBytes;
    }

    return totalBytes;
  }

  async uploadScreenThumb(blob: Blob) {

    // const currentUser = await this.dataService.getCurrentUser();
    // export canvas to png base 64
    // const imgBase64 = canvas.toDataURL('image/png');

    // // convert base64 to blob
    // const base64WithoutMime = imgBase64.split(',')[1];
    // const imgChars = atob(base64WithoutMime);
    // const byteNumbers = new Array(imgChars.length);
    // for (let i = 0; i < imgChars.length; i++) {
    //   byteNumbers[i] = imgChars.charCodeAt(i);
    // }

    // const byteArray = new Uint8Array(byteNumbers);
    // const blob = new Blob([byteArray]);

    // create file from blob
    // const file = new File([blob], 'screenThumb.png', { type: 'image/png', lastModified: Date.now() });

    // const newFileData = await this.libraryApi.uploadScreenThumb(this.currentUser.privateLibrary.id, { file: imgBase64 }).toPromise();

    // add file to upload data
    const formData: FormData = new FormData();
    formData.append('images', blob, 'screenshot.png');
    // let headers = new Headers();
    /** No need to include Content-Type in Angular 4*/
    // headers.append('Content-Type', 'multipart/form-data');
    // headers.append('Accept', 'application/json');



    // const options = new RequestOptions();
    // const endpoint = `${DataURLS.BASE_URL}/${DataURLS.API_VERSION}/libraries/${currentUser.privateLibrary.id}/uploadScreenThumb`;

    // // upload file
    // const newFileData = await this.http.post(endpoint, formData, options).map(res => res.json()).toPromise();

    // return newFileData.file;
  }

  // async elementToBlob(element: HTMLElement): Promise<Blob> {
  //   const canvas = await html2canvas(element);
  //   const blob = await this.getCanvasBlob(canvas);

  //   return blob;
  // }

  computedStyleToInlineStyle(element, recursive) {
    if (!element) {
      throw new Error('No element specified.');
    }

    if (recursive) {
      Array.prototype.forEach.call(element.children, (child) => {
        this.computedStyleToInlineStyle(child, recursive);
      });
    }

    const computedStyle = getComputedStyle(element, null);

    for (let i = 0; i < computedStyle.length; i++) {
      const property = computedStyle.item(i);
      const value = computedStyle.getPropertyValue(property);
      element.style[property] = value;
    }
  }

  getHtmlOfScreen(): string {
    // get html of element
    const elementCopy = this.screenPanel.nativeElement.cloneNode(true);
    // elementCopy.removeChild(elementCopy.children[0]); // remove display guides NOTE: not neccessary after switch to panel system
    const ss = document.styleSheets; // get all the style sheets

    // this.computedStyleToInlineStyle(elementCopy, true);  // this doesnt work for all style types :(  .. looks like we do it the hard way!

    // hard way... build style rule list but only for screen elements
    // looks for dummy style rule '.se-element'(this must be present on root of an Se-Element)
    let cssStr = '<style>';
    for (let index = 0; index < ss.length; index++) {
      const s: any = ss[index];
      if (!s.href) {
        if (_.get(s, 'rules[0].cssText', false) && s.rules[0].cssText.indexOf('se-element') > -1) {
          // add them to the style text
          for (let index2 = 0; index2 < s.rules.length; index2++) {
            const st = s.rules[index2];
            cssStr += st.cssText;
          }
        }
      }
    }
    cssStr += '</style>'; // close style tag



    let htmlWithStyle = cssStr + `<div style="background-color: ${this.backgroundColor} !important; width: ${this.config.width}; height: ${this.config.height};">` + elementCopy.innerHTML + `</div>`; // construct final html string

    htmlWithStyle = htmlWithStyle.split('transform:').join('-webkit-transform:'); // change trnasforms to webkit compatable versions

    // use posters as place holders for elements (easier for the server to render)
    for (const ele of this.componentsOnScreen) {
      // find video tag
      let foundStrs = [];
      // look for quickart
      if ((<any>ele).elementConfig.SeType === 'SeQuickArt') {
        const startIndex = htmlWithStyle.indexOf((<any>ele).elementConfig.getUniqueId);
        const searchstr = htmlWithStyle.substring(startIndex);
        foundStrs = searchstr.match(/<img [\s\S]*?>/);
      }

      // look for video elements
      if ((<any>ele).elementConfig.SeType && ['SeVideo', 'SeLiveVideo', 'SeVideoYoutube'].indexOf((<any>ele).elementConfig.SeType || '') > -1) {
        const startIndex = htmlWithStyle.indexOf((<any>ele).elementConfig.getUniqueId);
        const searchstr = htmlWithStyle.substring(startIndex);
        foundStrs = searchstr.match(/<vg-player [\s\S]*?<\/vg-player>/);
      }

      const newString = foundStrs && foundStrs.length ? foundStrs[0] : '';
      // get uniqueId from string
      // const index = newString.indexOf(`data-uniqueid="`);
      if (newString) {
        // const id = newString.substr(index + 15, 36);
        // get component ref from uniqueid
        // const cmp = this.getElementFromUniqueId(id);
        const cmp: any = ele;
        // replace element with poster img so it will render on the server
        if (cmp && cmp.elementConfig.poster) {
          htmlWithStyle = htmlWithStyle.replace(newString, `<img src="${cmp.elementConfig.poster}" style="100%; height:100%;">`);
        }
      }
    }

    return htmlWithStyle;
  }

  getElementFromUniqueId(id): any {
    // get angular component from html element (search uniqueId in data attribute)


    for (const cmp of this.componentsOnScreen) {
      if ((<ScreenElementClass>cmp).elementConfig.uniqueId === id) {
        return cmp; // found by unique id in data
      }
    }

    // check backgound component
    if (this.backgroundComponent) {
      if ((<ScreenElementClass>this.backgroundComponent).elementConfig.uniqueId === id) {
        return this.backgroundComponent; // found by unique id in data
      }
    }


  }

  escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
  }

  replaceAll(str, find, replace) {
    return str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
  }

  createComponent(elementConfig: any, makethumb = false, autoPlayOnPlayer = true): any {
    const newCmp = this.createComp(elementConfig, this.SeContainerRef.viewContainerRef, makethumb, autoPlayOnPlayer);
    this.hasChanges = true;
    return newCmp;
  }

  createComp(elementConfig: any, containerRef, makethumb, autoPlayOnPlayer): any {
    if (!elementConfig) {
      return;
    }

    const newComp = this.getComponentType(elementConfig); // get correct component type

    // get viewcontainer ref (this is where the new component is going to be inserted in the DOM)
    const viewContainerRef = containerRef;

    // We get a factory for the component we want to create
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(newComp);

    // create input object
    const data = { inputs: { elementConfig: elementConfig, autoPlayOnPlayer: autoPlayOnPlayer } };

    // must be in data.inputs format to be injected
    // Dynamic Injector
    const inputData = Object.keys(data.inputs).map((inputName) => { return { provide: inputName, useValue: data.inputs[inputName] }; });

    /////////////// depreciated in angular5
    // const resolvedInputs = ReflectiveInjector.resolve(inputData);
    // We create an injector out of the data we want to pass down to this components injector NOTE: call injector.get(propname) on new component
    // const injector = ReflectiveInjector.fromResolvedProviders(resolvedInputs, viewContainerRef.parentInjector);

    //////////////// new for angular 6
    // static injector
    const injector = Injector.create([...inputData]);

    // We create the component using the factory and the injector
    const componentRef = componentFactory.create(injector);


    // We insert the component into the dom container complete with inputs and outputs!
    viewContainerRef.insert(componentRef.hostView);

    // alternate creation method without injector
    // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(newComp);
    // const viewContainerRef = this.SeContainer.viewContainerRef;
    // viewContainerRef.clear();
    // const componentRef = viewContainerRef.createComponent(componentFactory);

    // add to master list of components on canvas now
    this.componentsOnScreen.push(componentRef.instance);

    // get native element ref from the newly created component
    // const nativeElementRef = componentRef.location.nativeElement;

    // set any styles and classes for the elements
    // this.renderer.addClass(nativeElementRef, 'screen-element');
    // this.renderer.setStyle(nativeElementRef, 'position', 'absolute');

    // componentRef.changeDetectorRef.detectChanges();
    (<any>componentRef).subscriptions = new Subscription();

    // subscribe to element events
    (<any>componentRef).subscriptions.add((<any>componentRef.instance).onMouseOverSubject.subscribe(e => this.onMouseOverElement(e)));
    (<any>componentRef).subscriptions.add((<any>componentRef.instance).onMouseLeaveSubject.subscribe(e => this.onMouseLeaveElement(e)));
    (<any>componentRef).subscriptions.add((<any>componentRef.instance).onMouseDownSubject.subscribe(e => this.onMouseDownElement(e)));
    (<any>componentRef).subscriptions.add((<any>componentRef.instance).onClickSubject.subscribe(e => this.onClickElement(e)));
    (<any>componentRef).subscriptions.add((<any>componentRef.instance).onTouchStartSubject.subscribe(e => this.onTouchStartElement(e)));
    (<any>componentRef).subscriptions.add((<any>componentRef.instance).onTouchEndSubject.subscribe(e => this.onTouchEndElement(e)));
    (<any>componentRef).subscriptions.add((<any>componentRef.instance).onScrollSubject.subscribe(e => this.onScrollElement(e)));

    if (makethumb) {
      (<any>componentRef).subscriptions.add((<any>componentRef.instance).onElementReadySubject.subscribe(e => this.onElementReady(e)));

    }

    // (<any>componentRef.instance).onTouchMoveSubject.subscribe(e => this.onTouchMoveElement(e));

    (<any>componentRef.instance).ref = componentRef;

    // send notice that a component was added
    this.componentAdded.emit({ screenPanelComponent: this, componentRef: componentRef });
    // do this to directly set public props on instance
    // (<SeImageComponent>componentRef.instance).imagepath = 'assets/images/cat.jpg';

    // return the instance created
    return componentRef.instance;
  }

  createBackgroundComp(elementConfig: any): any {
    if (!elementConfig) {
      return;
    }
    // delete any existing background element
    if (this.backgroundComponent) {
      this.deleteComponent(this.backgroundComponent);
    }


    // make component full panel size
    elementConfig.actualWidth = this.config.width;
    elementConfig.actualHeight = this.config.height;
    // set original sizes to match new flip
    elementConfig.originalSize.width = this.config.width;
    elementConfig.originalSize.height = this.config.height;
    elementConfig.position.x = 0;
    elementConfig.position.y = 0;
    elementConfig.zIndex = 3;
    elementConfig.lockAspect = false;


    const newComp = this.getComponentType(elementConfig); // get correct component type

    // get viewcontainer ref (this is where the new component is going to be inserted in the DOM)
    const viewContainerRef = this.SeContainerRef.viewContainerRef;

    // We get a factory for the component we want to create
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(newComp);

    // create input object
    const data = { inputs: { elementConfig: elementConfig } };

    // must be in data.inputs format to be injected
    // Dynamic Injector
    const inputData = Object.keys(data.inputs).map((inputName) => { return { provide: inputName, useValue: data.inputs[inputName] }; });

    /////////////// depreciated in angular5
    // const resolvedInputs = ReflectiveInjector.resolve(inputData);
    // We create an injector out of the data we want to pass down to this components injector NOTE: call injector.get(propname) on new component
    // const injector = ReflectiveInjector.fromResolvedProviders(resolvedInputs, viewContainerRef.parentInjector);

    // static injector
    const injector = Injector.create([...inputData]);

    // We create the component using the factory and the injector
    const componentRef = componentFactory.create(injector);

    // We insert the component into the dom container complete with inputs and outputs!
    viewContainerRef.insert(componentRef.hostView);

    this.backgroundComponent = componentRef.instance;

    componentRef.changeDetectorRef.detectChanges();

    (<any>componentRef.instance).ref = componentRef;

    // return the instance created
    return componentRef.instance;
  }

  async deleteBackgroundComp() {
    if (this.backgroundComponent) {
      this.hasChanges = true;
      await this.deleteComponent(this.backgroundComponent);
    }
  }

  getComponentType(elementConfig) {
    let newComp;

    // determine componenet type to create
    switch (elementConfig.SeType) {
      case SeImageComponent:
        newComp = SeImageComponent;
        break;
      case 'SeImage':
        newComp = SeImageComponent;
        break;
      case 'SeScrollingText':
        newComp = SeScrollingtextComponent;
        break;
      case 'SeTextbox':
        newComp = SeTextboxComponent;
        break;
      case 'SeLimitedTimeOffer':
        newComp = SeLimitedTimeOfferComponent;
        break;
      case 'SeVideo':
        newComp = SeVideoComponent;
        break;
      case 'SeLiveVideo':
        newComp = SeLiveVideoComponent;
        break;
      case 'SeQuickArt':
        newComp = SeQuickArtComponent;
        break;
      case 'SeShape':
        newComp = SeShapeComponent;
        break;
      case 'SeVideoYoutube':
        newComp = SeVideoYoutubeComponent;
        break;
      case 'SeWeatherMultiday':
        newComp = SeWeatherMultidayComponent;
        break;

      default:
        break;
    }

    return newComp;
  }

  async onElementReady(e: ScreenElementClass) {
    try {
      const data = await this.servicesApi.makeThumbnail(e.getHtml(), 160, 120, (<any>e.elementConfig).modelRef ? (<any>e.elementConfig).modelRef.Container : null).toPromise();
        e.currentThumbnail = data.imageData;
    } catch (error) {
      this.logger.error(`Error making thumbnail of element after adding to design:`, error);
    }

  }

  deleteComponentWithConfirm(componentRef: any) {
    this.confirmationService.confirm({
      key: 'elementDelete',
      header: 'Remove Element',
      icon: 'fa fa-question-circle',
      message: 'Remove element?',
      accept: async () => {
        await this.deleteComponent(componentRef);
      }
    });
  }

  async deleteComponent(componentRef: any) {

    // do any cleanup while component is still on the DOM
    if (componentRef.preDestroy) {
      await componentRef.preDestroy();
    }

    // remove all subscriptions
    if ((<any>componentRef).subscriptions) {
      (<any>componentRef).subscriptions.unsubscribe();
      (<any>componentRef).subscriptions = null;
    }

    if (componentRef === this.backgroundComponent) {
      try {
        componentRef.ref.destroy();
        this.changeDetectorRef.detectChanges();

        await new Promise(resolve => setTimeout(resolve, 0)); // give chance for object to finalize
        this.backgroundComponent = null;

        // setup for GC
        Object.keys(componentRef).map(k => {
          componentRef[k] = null;
        });

        componentRef = null;
      } catch (error) {

      }

      this.hasChanges = true;
    } else {
      const index = this.componentsOnScreen.indexOf(componentRef);
      this.componentsOnScreen.splice(index, 1);

      this.hasChanges = true;

      // notify any listners
      this.componentDeleted.emit({ screenPanelComponent: this, componentRef: componentRef });
      try {


        // setup for GC
        if (componentRef && componentRef.ref) {

          componentRef.ref.destroy();

          // Object.keys(componentRef.ref).map(k => {
          //   if (k !== 'vgapi') {
          //     componentRef.ref[k] = null;
          //   }
          // });


          componentRef.ref = null;
        }


      } catch (error) {
        this.logger.error('Could not destory component.ref correctly', error);
      }

      try {
        // setup for GC
        // Object.keys(componentRef).map(k => {
        //   componentRef[k] = null;
        // });
      } catch (error) {
        this.logger.error('Could not destory componentRef correctly', error);
      }

      componentRef = null;

      this.compressZindexs(); // make zindexes accurate
    }

  }

  onMouseDownPanel(event) {
    this.mouseDownPanel.emit({ screenPanelComponent: this, event: event });
  }

  onMouseOverElement(event) {
    // show hover adorner, except on mobile
    this.mouseOverElement.emit({ screenPanelComponent: this, componentRef: event.componentRef, event: event.event });
  }

  onMouseLeaveElement(event) {
    // do not use this event!
    // this gets fired right after the MouseOver/MouseEnter becuase the hover adorner is set to cover it on enter!
  }

  onMouseDownElement(event) {
    // this.logger.info('onMouseDown element');
    this.mouseDownElement.emit({ screenPanelComponent: this, componentRef: event.componentRef, event: event.event });
  }

  // mobile devices have no hover adorner, so they will produce a click on the element itself
  onClickElement(event) {
    // this.logger.info('onClick element');
    this.clickElement.emit({ screenPanelComponent: this, componentRef: event.componentRef, event: event.event });
  }

  onTouchStartElement(event) {
    // this.logger.info('onTouchStart element');
    this.touchStartElement.emit({ screenPanelComponent: this, componentRef: event.componentRef, event: event.event });
  }

  onTouchEndElement(event) {
    // this.logger.info('onTouchEnd element');
    this.touchEndElement.emit({ screenPanelComponent: this, componentRef: event.componentRef, event: event.event });
  }

  onScrollElement(event) {
    // pass event to the zoom controller box
    // console.log('scrolled on element');
    this.scrollElement.emit({ screenPanelComponent: this, componentRef: event.componentRef, event: event.event });
  }


}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/components/screen-panel/screen-panel.component.ts